"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.featureTogglesContext = void 0;
var _react = _interopRequireDefault(require("react"));
/** @deprecated Use the `featureTogglesContext` constant from the `@ori/feature-toggles` library */
const featureTogglesContext = exports.featureTogglesContext = /*#__PURE__*/_react.default.createContext([]);
